import { DialogOverlay, DialogOverlayActions, DialogOverlayFooter, TextField, Paragraph, Button } from '@fs/zion-ui'
import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

export default function RemoveRelationshipPersonDialog({
  parent1Id,
  parent2Id,
  childId,
  personToRemove,
  onEdit,
  ...overlay
}) {
  const { t } = useTranslation()
  const [reason, setReason] = useState('')
  const focusElementRef = useRef()

  let finalParent1 = parent1Id
  let finalParent2 = parent2Id
  if (finalParent1 === personToRemove.personId) {
    finalParent1 = ''
  } else {
    finalParent2 = ''
  }

  return (
    <DialogOverlay
      {...overlay}
      focusRef={focusElementRef}
      title={t('person.relationships.editRelationshipTitle', 'Edit Relationship')}
    >
      <Paragraph size="sm">
        {t(
          'person.relationships.editRelationshipBody',
          'Are you sure you want to remove this person from the relationship?'
        )}
      </Paragraph>
      <Paragraph size="sm">{`${personToRemove.name} (${personToRemove.personId})`}</Paragraph>
      <TextField
        ref={focusElementRef}
        label={t('reason', 'Reason')}
        value={reason}
        onChange={(event) => setReason(event.target.value)}
      />
      <DialogOverlayFooter>
        <DialogOverlayActions>
          <Button onClick={() => onEdit(reason, finalParent1, finalParent2, childId)} emphasis="high">
            {t('action.confirm', 'Confirm')}
          </Button>
          <Button id="cancelRemoveRelationshipBtn" onClick={overlay.close}>
            {t('action.cancel', 'Cancel')}
          </Button>
        </DialogOverlayActions>
      </DialogOverlayFooter>
    </DialogOverlay>
  )
}
